import Box from "@sendsprint/ui-react/components/box";
import Typography from "@sendsprint/ui-react/components/typography";
import { FC, ReactNode } from "react";
import Link from "next/link";

interface LinkData {
  title: string;
  url: string;
  externalLink?: string;
}

export interface FooterColumnProps {
  title?: string;
  links?: LinkData[];
  className?: string;
  children?: ReactNode;
}

const FooterColumn: FC<FooterColumnProps> = ({
  title,
  links,
  children,
  className,
}) => {
  return (
    <Box className={className}>
      {title && (
        <Typography
          as="h3"
          variant="h6"
          className="ss:font-bold ss:my-3 ss:text-neutral-50"
        >
          {title}
        </Typography>
      )}
      {links ? (
        <ul>
          {links.map((link) => {
            if (link.externalLink) {
              return (
                <li key={link.title} className="ss:my-6">
                  <a
                    key={link.title}
                    href={link.externalLink}
                    className="ss:text-transparent ss:relative ss:text-caption ss:md:text-body"
                    target="_blank"
                    rel="noreferrer"
                  >
                    <Typography
                      variant={"paragraphRegular"}
                      className="ss:absolute ss:flex ss:justify-center ss:items-center ss:-left-3 ss:-right-3 ss:-top-3 ss:-bottom-3 ss:duration-300 ss:hover:bg-primary1-500 ss:text-neutral-300 ss:hover:text-neutral-50 ss:rounded-lg "
                    >
                      <span>{link.title}</span>
                    </Typography>
                    {link.title}
                  </a>
                </li>
              );
            } else {
              return (
                <li key={link.title} className="ss:my-6">
                  <Link
                    key={link.title}
                    href={link.url}
                    className="ss:text-transparent ss:relative ss:text-caption ss:md:text-body"
                  >
                    <Typography
                      variant={"paragraphRegular"}
                      className="ss:absolute ss:flex ss:justify-center ss:items-center ss:-left-5 ss:-right-5 ss:-top-3 ss:-bottom-3 ss:duration-300 ss:hover:bg-primary1-500 ss:text-neutral-300 ss:hover:text-neutral-50 ss:rounded-lg "
                    >
                      <span>{link.title}</span>
                    </Typography>
                    {link.title}
                  </Link>
                </li>
              );
            }
          })}
        </ul>
      ) : (
        children
      )}
    </Box>
  );
};

export default FooterColumn;
